(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/kambi-offering/assets/javascripts/accessibility-helpers.js') >= 0) return;  svs.modules.push('/components/oddset/kambi-offering/assets/javascripts/accessibility-helpers.js');
"use strict";


const getOutcomeAriaLabel = outcome => {
  let ariaLabel;
  if (outcome.label) {
    ariaLabel = "Spela p\xE5 utfall ".concat(outcome.label, ".");
  }
  if (outcome.odds) {
    ariaLabel += " Odds: ".concat(outcome.odds, ".");
  } else {
    ariaLabel += ' Odds ej tillgängligt.';
  }
  return ariaLabel;
};
const exported = {
  getOutcomeAriaLabel
};
if (svs.isServer) {
  module.exports = exported;
} else {
  setGlobal('svs.components.oddset.kambiOffering', exported);
}

 })(window);